import { createStyles,ThemeColors } from 'core/utilities/theme';

export default createStyles({
  content: {
    position: 'absolute',
    minWidth: '100%',
    borderBottom: `1px solid ${ThemeColors.sequenceAnalyserBorder}`,
  },
});
